// @flow

import * as React from "react";

const COLORS = ["#224514", "#4f8a3a", "#dce7d6", "#3b7dd8", "#f5b700", "#ff6b6b", "#9b5de5"];

// Plain CSS confetti (no library, nothing for the CSP to block): pieces fall once from the top of the screen and
// fade out. pointer-events: none, so it never gets in the way; prefers-reduced-motion hides it (App.css).
function Confetti({count = 140}: {|+count?: number|}): React.Node {
    const pieces = React.useMemo(() => Array.from({length: count}, (_, i) => ({
        left: Math.random() * 100,
        delay: Math.random() * 2.5,
        duration: 3 + Math.random() * 2.5,
        drift: (Math.random() - 0.5) * 240,
        spin: 360 + Math.random() * 720,
        width: 6 + Math.random() * 6,
        height: 8 + Math.random() * 8,
        color: COLORS[i % COLORS.length],
        round: Math.random() < 0.3,
    })), [count]);

    return (
        <div className="confetti" aria-hidden="true">
            {pieces.map((p, i) => (
                <span key={i} className="confetti-piece" style={{
                    left: p.left + "%",
                    width: p.width + "px",
                    height: (p.round ? p.width : p.height) + "px",
                    background: p.color,
                    borderRadius: p.round ? "50%" : "2px",
                    animationDelay: p.delay + "s",
                    animationDuration: p.duration + "s",
                    "--confetti-drift": p.drift + "px",
                    "--confetti-spin": p.spin + "deg",
                }} />
            ))}
        </div>
    );
}

export default Confetti;
